
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.03 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M19.26 8.26a2.68 2.68 0 012 .81 2.71 2.71 0 010 3.86 2.67 2.67 0 01-2 .81l-5.48-.1v5.62a2.64 2.64 0 01-.78 1.93 2.68 2.68 0 01-2 .81 2.62 2.62 0 01-1.95-.81 2.66 2.66 0 01-.79-1.93l.1-5.62-5.62.1a2.62 2.62 0 01-1.95-.81 2.75 2.75 0 010-3.86 2.62 2.62 0 011.95-.81h5.62l-.1-5.52A2.66 2.66 0 019.05.81 2.62 2.62 0 0111 0a2.68 2.68 0 012 .81 2.64 2.64 0 01.81 1.93v5.52z"}})])
          )
        }
      }
    